export default {
  init() {
    // JavaScript to be fired on all pages    
    $(() => {                      
      window.onscroll = () => {
        if(!$( '#toggle_main_header' ).length) return;
        if(window.pageYOffset > 0)
        {
          $( '#toggle_main_header' ).fadeOut( 1, () =>{
            $( '#sticky-header' ).fadeIn( 'slow');
          });          
        }
        else
        {          
          $( '#sticky-header' ).fadeOut( 1, () => {
            $( '#toggle_main_header' ).fadeIn( 'slow');
          });
        }
      }
     
      $('*[data-open="video-modal"]').on('click', (e) => {
        let url = $(e.currentTarget).attr('data-url');        
        $('.video-modal iframe').attr('src', url);   
      });

      $('.video-modal').on('closed.zf.reveal', function () {        
        $('.video-modal iframe').attr('src', '');        
      });
    }); 
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js